import type { AxiosRequestConfig } from 'axios';
import { post } from '@/utils/network/axios-helper';
import type { IPageDataBoxType, IGetAnswerList, ISaveAnswerList, IParamsType, IResult } from '@/utils/ctype';
import { EXAM_REQUEST_TIMEOUT_MS } from './start';

export const getListeningContent = (params: IParamsType) => {
  return post<{list: IPageDataBoxType[];}>('/api/simulate/get-listening-info', params);
};

export const getAnswerList = (params: IParamsType) => {
  return post<IGetAnswerList>('/api/simulate/get-listening-draft-info', params);
};

export const saveAnswerList = (params: ISaveAnswerList, config?: AxiosRequestConfig) => {
  return post<{id:number;}>('/api/simulate/save-listening-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const submitAnswer = (params: IParamsType, config?: AxiosRequestConfig) => {
  return post<{id:number;}>('/api/simulate/finished-listening', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const getResult = (params: IParamsType) => {
  return post<IResult>('/api/simulate/get-listening-record-answer-info', params);
};
